var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticClass:"border-bottom shadow-sm",attrs:{"type":"dark","variant":"dark"}},[_c('b-navbar-brand',{staticClass:"m-auto"},[_vm._v("Pazzle")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }